import "././App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./Pages/Home/Index";
import Withering from "./Layout/Navbar/Dropdown/Withering";
import Rolling from "./Layout/Navbar/Dropdown/Rolling";
import Fermenting from "./Layout/Navbar/Dropdown/Fermenting";
import Drying from "./Layout/Navbar/Dropdown/Drying";
import Sorting from "./Layout/Navbar/Dropdown/Sorting";
import Packing from "./Layout/Navbar/Dropdown/Packing";
import Utilities from "./Layout/Navbar/Dropdown/Utilities";
import PageComing from "./Pages/ComingSoon/PageComing";
import Quality from "./Layout/Navbar/Dropdown/Quality";
import Workshop from "./Layout/Navbar/Dropdown/Workshop";
import Introduction from "./Pages/Components/Mms";
import Manufacturing from "./Pages/Components/Manufacturing";
import HighTensile from "./Pages/Components/HighTensile";
import Product from "./Pages/Components/Product";
import ProcessingCard from "./Pages/TeaProcessingCard/Index";
import { useEffect } from "react";
import GroupProfile from "./Pages/AboutUs/Profile";
import CompanyProfile from "./Pages/AboutUs/CompanyProfile";
import VisionMission from "./Pages/AboutUs/VisionMission";
import ManagementTeam from "./Pages/AboutUs/ManagmentTeam";
import AwardRecognition from "./Pages/AboutUs/AwardRecognition";
import Clientele from "./Pages/AboutUs/Clientele";
import QualityPolicy from "./Pages/AboutUs/QualityPolicy";
import Research from "./Pages/AboutUs/Research";
import Facilities from "./Pages/Facilities/Facilities";
import Adresses from "./Pages/ContactUs/Addresses";
import QueryForm from "./Pages/ContactUs/QueryForm";
import WorkingCareer from "./Pages/Carreers/Working.career";
import ApplyOnline from "./Pages/Carreers/ApplyOnline";
import Blog from "./Pages/Blog/Blog";
import BlogDetail from "./Pages/Blog/BlogDetails";
import News from "./Pages/Media/News";
import Gallery from "./Pages/Media/Gallery";
import Download from "./Pages/Media/Donwload";
// import CSR from "./Pages/Csr/Csr";
import TeaWithering from "./Pages/OrthodoxTeaProcessing/TeaWithering";
import TeaRolling from "./Pages/OrthodoxTeaProcessing/TeaRolling";
import TeaFermenting from "./Pages/OrthodoxTeaProcessing/TeaFermenting";
import TeaDrying from "./Pages/OrthodoxTeaProcessing/TeaDrying";
import TeaSorting from "./Pages/OrthodoxTeaProcessing/TeaSorting";
import GreenSteaming from "./Pages/GreenTeaprocessing/GreenSteaming";
import GreenPacking from "./Pages/GreenTeaprocessing/GreenPacking";
import GreenSorting from "./Pages/GreenTeaprocessing/GreenSorting";
import GreenDrying from "./Pages/GreenTeaprocessing/GreenDrying";

import Foreign from "./Pages/GardenPlantMachienry/Foreign";
import Plucking from "./Pages/GardenPlantMachienry/Plucking";
import TeaIngredient from "./Pages/GardenPlantMachienry/TeaIngredient";
import GreenRolling from "./Pages/GreenTeaprocessing/TeaProcessingRolling";
import HotDip from "./Pages/HotDipGalvanization/HotDip";
import MmsLearnMore from "./Pages/MmsLearnMore/MmsLearnMore";
import HdpLearnMore from "./Pages/HotDipGalvanization/HotDip";
import HotDipIntroduction from "./Pages/HotDipGalvanization/Components/introduction";
import ServiceCapabilities from "./Pages/HotDipGalvanization/Components/ServiceCapabilities";
import TechnicalSpecification from "./Pages/HotDipGalvanization/Components/TechnicalSpecification";
import GalvanizingProcess from "./Pages/HotDipGalvanization/Components/GalvanizingProcess";
import QualityAssurance from "./Pages/HotDipGalvanization/Components/QualityAssurance";
import WhyChooseVikramIndia from "./Pages/HotDipGalvanization/Components/WhyChooseVikram";
import ProfileAvailability from "./Pages/Components/ProfileAvailability";
import BlackTeaCard from "./Pages/BlackTeaCard/Index";
import GreenBlending from "./Pages/GreenTeaprocessing/GreenBlending";
import TmdDivision from "./Pages/TMD/TmdDivision";
import Harvesting from "./Pages/GardenPlantation/Harvesting";
import ForeignObject from "./Pages/GardenPlantation/ForeignObject";
import Laboratory from "./Pages/GardenPlantation/Laboratory";
import AppLayout from "./Layout/AppLayout";
import NoticeDetails from "./Pages/Home/Components/NoticeDetails";

import Landing from "./Pages/Landing/Landing";
import AllNotice from "./Pages/Home/Components/AllNotice";
import MediaDetails from "./Pages/Home/Components/MediaDetails";
import SuccessPage from "./Pages/Sucess/SuccessPage";

import TowerLineTransmission from "./Pages/Tlt/TowerLineTransmission";
import Certificate from "./Pages/AboutUs/Certificate";

import WorldMapLocation from "./Pages/Worlmapsection/WorldMapLocation";
import WorldMapLocationDetails from "./Pages/Worlmapsection/WorldMapLocationDetails";



import InfrastructureMachineryTlt from "./Pages/Tlt/InfrastructureMachineryTlt";
import ProductPortfolioTlt from "./Pages/Tlt/ProductPortfolioTlt";
import TechnicalSpecificationsTlt from "./Pages/Tlt/TechnicalSpecificationsTlt";
import QualitySafetyTlt from "./Pages/Tlt/QualitySafetyTlt";


function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <BrowserRouter>


      <Routes>
        <Route
          path="/"
          element={
            sessionStorage.getItem("visited")
              ? <Navigate to="/home" />
              : <Landing />
          }
        />
        <Route element={<AppLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/products/ctc/withering-process" element={<Withering />} />
          <Route path="/products/ctc/rolling-process" element={<Rolling />} />
          <Route path="/products/ctc/oxidation-process" element={<Fermenting />} />
          <Route path="/products/ctc/drying-process" element={<Drying />} />
          <Route path="/products/ctc/sorting,cleaning,grading-and-storage-system" element={<Sorting />} />
          <Route path="/products/ctc/workshop-machinery" element={<Packing />} />
          <Route path="/products/ctc/utilities" element={<Utilities />} />
          <Route path="/products/ctc/teawithering-process" element={<TeaWithering />} />
          <Route path="/products/ctc/tearolling-process" element={<TeaRolling />} />
          <Route path="/products/ctc/teaoxidation-process" element={<TeaFermenting />} />
          <Route path="/products/ctc/teadrying-process" element={<TeaDrying />} />
          <Route path="/products/ctc/teasorting,cleaning,grading-and-storage-system" element={<TeaSorting />} />

          <Route path="/products/ctc/greensteaming-process" element={<GreenSteaming />} />
          <Route path="/products/ctc/greensorting-&-grading-process" element={<GreenPacking />} />
          <Route path="/products/ctc/greendrying-process" element={<GreenSorting />} />
          <Route path="/products/ctc/greenrolling-and-shaping-process" element={<GreenDrying />} />
          <Route path="/products/ctc/greenroasting-process" element={<GreenRolling />} />
          <Route path="/products/ctc/greenfinal-blending" element={<GreenBlending />} />
          <Route path="/products/ctc/harvesting" element={<Harvesting />} />
          <Route path="/products/ctc/foreign-object-remover" element={<Foreign />} />
          <Route path="/products/ctc/plucking-machine" element={<Plucking />} />
          <Route path="/products/ctc/tea-ingredients--analyzer" element={<TeaIngredient />} />
          <Route
            path="/products/ctc/quality-control-equipment"
            element={<Quality />}
          />
          <Route path="/products/ctc/workshop-equipment" element={<Workshop />} />
          <Route path="/products/mms/infrastructure-&-machinery" element={<Introduction />} />
          <Route path="/products/towerline-transmission/infrastructure-machinery" element={<InfrastructureMachineryTlt />} />
          <Route path="/products/towerline-transmission/product-portfolio" element={<ProductPortfolioTlt />} />
          <Route path="/products/towerline-transmission/technical-specifications" element={<TechnicalSpecificationsTlt />} />
          <Route path="/products/towerline-transmission/quality-safety" element={<QualitySafetyTlt />} />





          <Route
            path="/products/mms/product-&-portfolio"
            element={<Manufacturing />}
          />
          <Route
            path="/products/mms/profile-availability"
            element={<ProfileAvailability />}
          />
          <Route
            path="/products/mms/technical-specification"
            element={<HighTensile />}
          />
          <Route path="/products/mms/quality-&-safety" element={<Product />} />



          <Route path="/about/group-profile" element={<GroupProfile />} />
          <Route path="/about/company-profile" element={<CompanyProfile />} />
          <Route path="/about/certificates" element={<Certificate />} />

          <Route path="/about/vision-&-mission" element={<VisionMission />} />
          <Route path="/about/management-team" element={<ManagementTeam />} />
          <Route
            path="/about/awards-and-recognitions"
            element={<AwardRecognition />}
          />


          <Route path="/products/processing-card" element={<ProcessingCard />} />
          <Route path="/about/group-profile" element={<GroupProfile />} />
          <Route path="/about/company-profile" element={<CompanyProfile />} />
          <Route path="/about/vision-&-mission" element={<VisionMission />} />
          <Route path="/about/management-team" element={<ManagementTeam />} />


          <Route path="/about/clientele" element={<Clientele />} />
          <Route path="/about/quality-policy" element={<QualityPolicy />} />
          <Route path="/about/research-and-development" element={<Research />} />
          <Route path="/page-coming-soon" element={<PageComing />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact/addresses" element={<Adresses />} />
          <Route path="/contact/query-form" element={<QueryForm />} />
          <Route path="/careers/working-with-us" element={<WorkingCareer />} />
          <Route path="/careers/apply-now" element={<ApplyOnline />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/blog-detail/:slug" element={<BlogDetail />} />

          <Route path="/notice/:id" element={<NoticeDetails />} />
          <Route path="/all-notices" element={<AllNotice />} />


          <Route path="/media/news" element={<News />} />
          <Route path="/media/photo-gallery" element={<Gallery />} />
          <Route path="/media/download" element={<Download />} />
          <Route path="/media/details/:id" element={<MediaDetails />} />


          <Route path="/products/hot-dip" element={<HotDip />} />
          <Route path="/products/mms-learnMore" element={<MmsLearnMore />} />
          <Route path="/products/hdp-learnMore" element={<HdpLearnMore />} />
          <Route path="/products/introduction" element={<HotDipIntroduction />} />
          <Route path="/products/service-capabilities" element={<ServiceCapabilities />} />
          <Route path="/products/technical-specification-&-infrastructure" element={<TechnicalSpecification />} />
          <Route path="/products/the-galvanizing-process" element={<GalvanizingProcess />} />
          <Route path="/products/quality-assurance-&-lab-facilities" element={<QualityAssurance />} />
          <Route path="/products/why-choose-us" element={<WhyChooseVikramIndia />} />
          <Route path="/about/clientele" element={<Clientele />} />
          <Route path="/about/quality-policy" element={<QualityPolicy />} />
          <Route path="/about/research-and-development" element={<Research />} />
          <Route path="/page-coming-soon" element={<PageComing />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact/addresses" element={<Adresses />} />
          <Route path="/contact/query-form" element={<QueryForm />} />
          <Route path="/careers/working-with-us" element={<WorkingCareer />} />
          <Route path="/careers/apply-now" element={<ApplyOnline />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/blog-detail/:slug" element={<BlogDetail />} />
          <Route path="/media/news" element={<News />} />
          <Route path="/media/photo-gallery" element={<Gallery />} />
          <Route path="/media/download" element={<Download />} />
          {/* <Route path="/csr" element={<CSR />} /> */}
          <Route path="/products/hot-dip" element={<HotDip />} />
          <Route path="/products/mms-learnMore" element={<MmsLearnMore />} />
          <Route path="/products/towerline-transmission" element={<TowerLineTransmission />} />
          <Route path="/products/hdp-learnMore" element={<HdpLearnMore />} />
          <Route path="/products/introduction" element={<HotDipIntroduction />} />
          <Route path="/products/service-capabilities" element={<ServiceCapabilities />} />
          <Route path="/products/technical-specification-&-infrastructure" element={<TechnicalSpecification />} />
          <Route path="/products/the-galvanizing-process" element={<GalvanizingProcess />} />
          <Route path="/products/quality-assurance-&-lab-facilities" element={<QualityAssurance />} />
          <Route path="/products/why-choose-us" element={<WhyChooseVikramIndia />} />
          <Route path="/products/tea-processing-machinery/black-tea" element={<BlackTeaCard />} />
          <Route path="/products/tea-processing-machinery/Tmd-Division-machine-structure" element={<TmdDivision />} />
          <Route path="/products/garden-&-plantation-equipments/harvesting-tool" element={<Harvesting />} />
          <Route path="/products/garden-&-plantation-equipments/foreign-object-remover-tool" element={<ForeignObject />} />
          <Route path="/products/garden-&-plantation-equipments/laboratory-&-quality-assurance-tool" element={<Laboratory />} />
          <Route path="/thankyou-page" element={<SuccessPage />} />
          <Route path="/acousto-scan" element={<WorldMapLocation />} />
        </Route>
        <Route
          path="/:country"
          element={<WorldMapLocationDetails />}
        />
      </Routes>

    </BrowserRouter>
  );
}

export default App;